import { render, staticRenderFns } from "./DrybrushFooter.vue?vue&type=template&id=341ba652&"
import script from "./DrybrushFooter.vue?vue&type=script&lang=js&"
export * from "./DrybrushFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports